import React from 'react';
import { useHistory } from 'react-router-dom';

import SuccessIcon from '../../components/sign-result/icons/success.svg';
import IconBtn from '../../modules/icon-btn/icon-btn';
import NoticeBig from '../../modules/notice-big/notice-big';
import PageHeader from '../../modules/page-header';
import TableHeaderWrapper from '../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';

import './main.scss';

const EmptyChapter: React.FC = () => {
  const history = useHistory();

  const { pathname } = history.location;

  let titleChapter = '';
  switch (pathname) {
    case '/agents':
      titleChapter = 'Поставщики';
      break;
    default:
      break;
  }

  const SubmitBtn = (
    <IconBtn
      title="Закрыть и перейти на главную"
      onClick={() => {
        history.push('/');
      }}
    />
  );

  return (
    <div className="container">
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <PageHeader
            items={[{ link: '', title: titleChapter }]}
            iconType="agents"
          />
        </div>
      </div>
      <TableWrapper>
        <div className="page-blank">
          <div className="page-blank__header">
            <TableHeaderWrapper />
          </div>
          <div className="page-blank__body">
            <NoticeBig
              title="Раздел находится в разработке"
              bottom={SubmitBtn}
              icon={SuccessIcon}
              text="В данный момент этот раздел находится в активной разработке и будет доступен в ближайшем релизе"
              link=""
            />
          </div>
        </div>
      </TableWrapper>
    </div>
  );
};

export default EmptyChapter;
